import request from '@/axios';

export const getSaleSchemeList = (query) => {
  return request({
    url: '/lebo-trade/distributionrule/list',
    method: 'get',
    params: query
  })
}

// 插入数据
export const addSaleScheme = (query) => {
  return request({
    url: '/lebo-trade/distributionrule/submit',
    method: 'post',
    data: query
  })
}

// 删除营销配置
export const deleteSaleScheme = (query) => {
  return request({
    url: '/lebo-trade/distributionrule/remove',
    method: 'post',
    data: query
  })
}

// 获取企业会员商品列表
export const getProductList = () => {
  return request({
    url: '/lebo-trade/product/product-simple/list',
    method: 'GET'
  })
}

export const getPartnerList = (query) => {
  return request({
    url: '/lebo-user/distributor/page',
    method: 'get',
    params: query
  })
}

// 提现记录
export const getWithdrawLogs = (query) => {
  return request({
    url: '/lebo-user/userwithdrawal/page',
    method: 'get',
    params: query
  })
}

// 获取收益记录
export const getIncomeLogs = (query) => {
  return request({
    url: '/lebo-user/userincome/page',
    method: 'get',
    params: query
  })
}

// 绑定设备记录
export const getBindedDevices = (query) => {
  return request({
    url: '/lebo-device/receiver/page',
    method: 'get',
    params: query
  })
}

// 提交审核
export const approveRequire = (query) => {
  return request({
    url: '/lebo-trade/distributionrule/submit-examine',
    method: 'post',
    data: query
  })
}

// 审核操作
export const submitApprove = (data) => {
  return request({
    url: '/lebo-trade/distributionrule/update-examine',
    method: 'POST',
    data
  })
}
